export enum RequestAutoAccept {
  REQUIRED = 'required',
  OPTIONAL = 'optional',
}
